import { render } from "./InformationBox.vue?vue&type=template&id=4dca79cb&scoped=true"
const script = {}

import "./InformationBox.vue?vue&type=style&index=0&id=4dca79cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dca79cb"]])

export default __exports__